import _map from 'lodash/map';
import _get from 'lodash/get';
import { v4 as uuidv4 } from 'uuid';

import initialState from './initialState';
import actionType from './actionTypes';

const groupConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ALL_RECON_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                reconConfigurations: action.payload,
                gridReconConfigurations: {
                    fielddata: initialState.gridReconConfigurations.fielddata,
                    instances: _map(action.payload, (config) => ({
                        ...config,
                        id: uuidv4(),
                        filing_date: null,
                    })),
                },
                reconNames: _map(action.payload, 'recon_name'),
            };
        }
        case actionType.GET_RECON_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                reconConfig: {},
            };
        }
        case actionType.GET_RECON_DEFAULT_MAPPING_SUCCESS: {
            if (action.payload.length === 0) {
                return {
                    ...state,
                    reconSourceMatchingType: {
                        label: 'Reconciliation',
                        value: 'Reconciliation',
                    },
                    reconSourceMappings: action.payload,
                };
            } else {
                const { mappings, config } = action.payload;
                return {
                    ...state,
                    reconSourceMatchingType: {
                        label: _get(config, 'source_type', 'Supplementary'),
                        value: _get(config, 'source_type', 'Supplementary'),
                    },
                    reconSourceMappings: mappings,
                };
            }
        }

        case actionType.GET_GROUP_SOURCE_NAME_MAPPINGS:
            return {
                ...state,
                groupSourceNameMappings: action.payload,
                groupSourceNameMappingsForSelectionBox: _map(action.payload, (o) => ({
                    ...o,
                    label: o.source_name,
                    value: o.ref_id,
                })),
            };
        case actionType.GET_RECON_SOURCE_FILTER_SUCCESS:
            return {
                ...state,
                reconSourceFilters: _map(action.payload, (filter) => ({
                    operator: {
                        label: filter.operator_label,
                        value: filter.operator_value,
                    },
                    columnName: {
                        label: filter.filter_column_label,
                        value: filter.filter_column_value,
                    },
                    filterValue: filter.filter_value,
                    condition: {
                        label: filter.filter_type_label,
                        value: filter.filter_type_value,
                    },
                })),
            };

        case actionType.GET_RECON_FIELD_MAPPING_SUCCESS:
            return {
                ...state,
                reconFieldConfigurations: action.payload,
            };

        case actionType.GET_GROUP_SOURCE_FIELD_MAPPINGS_SUCCESS:
            return {
                ...state,
                groupSourceFieldMappings: action.payload,
            };
        case actionType.GET_RECON_CALCULATION_FILTER_SUCCESS:
            return {
                ...state,
                calculationFilterFormProps: action.payload,
            };
        case actionType.SET_IS_SHOW_MODAL:
            return {
                ...state,
                isShowModal: action.payload,
            };

        case actionType.GET_RECON_CONFIGURATION_SUCCESS_FOR_SIDEBAR:
            return {
                ...state,
                reconNamesForSideBar: _map(action.payload, 'recon_name'),
            };

        case actionType.GET_GROUP_SOURCE_FIELD_SQL_EXPRESSION_SUCCESS:
            return {
                ...state,
                groupSourceSQLExpression: action.payload,
            };

        case actionType.GET_RECON_SOURCE_AGGREGATION_RESULT:
            return {
                ...state,
                reconSourceFieldAggregationMappings: action.payload,
            };
        case actionType.GET_RECON_SUMMARY_TYPES:
            return {
                ...state,
                reconSummaryTypes: action.payload,
            };

        case actionType.GET_GROUP_SOURCE_LOOKUP_CONFIGURATION_SUCCESS:
            return {
                ...state,
                groupSourceFieldsMappingsForLookup: action.payload,
            };
        case actionType.GET_SOURCE_MAPPING:
            return {
                ...state,
                sourceMappedGroups: action.payload,
            };
        default:
            return state;
    }
};

export default groupConfigurationReducer;
